export class ProgressorResult {
    value = "";
    error = false;
}
